import * as types from '../mutation-types';

export const state = {
    placeSelected: {},
    placeType: null,
    recentSeletedPlace: {},
    btnState: '',
    hotel: {}
}
export const getters = {
    hotel: state => state.hotel,
    placeSelected: state => state.placeSelected,
    placeType: state => state.placeType, 
    btnState: state => state.btnState,
    recentSeletedPlace: state => state.recentSeletedPlace,
}
export const mutations = {
    [types.SELECTED_LOCATION](state, payload) {
        state.placeSelected = payload;
    },
    [types.SELECTED_LOCATION_TYPE](state, payload) {
        state.placeType = payload;
    },

    [types.BTN_STATE](state, payload) {
        state.btnState = payload;
    },
    [types.RECENT_PLACE](state, payload) {
        state.recentSeletedPlace = payload;
    },
    setHotel(state, payload) {
        state.hotel = payload;
    }
}
export const actions = {

    async setHotel({  commit }, payload) {
        commit('setHotel', payload);
    },
    async setLocation({
        commit
    }, payload) {
        commit(types.SELECTED_LOCATION, payload);
    },
    async setplaceType({
        commit
    }, payload) {
        commit(types.SELECTED_LOCATION_TYPE, payload);
    },

    async setBtnState({
        commit
    }, payload) {
        commit(types.BTN_STATE, payload);
    },
    async setRecentPlace({
        commit
    }, payload) {
        commit(types.RECENT_PLACE, payload);
    }
}